import { Injectable, HostListener } from '@angular/core';
import { BehaviorSubject, Observable, Subscriber } from 'rxjs';

// Menu
export interface Menu {
	path?: string;
	title?: string;
	icon?: string;
	type?: string;
	badgeType?: string;
	badgeValue?: string;
	active?: boolean;
	bookmark?: boolean;
    children?: Menu[];
    accessarea?: string;
}

@Injectable({
	providedIn: 'root'
})

export class NavService {
    public screenWidth: any
	public collapseSidebar: boolean = false

	constructor() {
		this.onResize();
		if (this.screenWidth < 991) {
			this.collapseSidebar = true
		}
	}

	// Windows width
	@HostListener('window:resize', ['$event'])
	onResize(event?) {
		this.screenWidth = window.innerWidth;
	}

	MENUITEMS: Menu[] = [
		{
            title: 'Designer', icon: 'slack', type: 'sub', badgeType: 'primary', accessarea: "25000:SWR", badgeValue: 'New', active: false, children: [
                { path: 'App/Template/Offer/Search', title: 'Offer', type: 'link' , accessarea: "25001:SWR"},
                { path: 'App/Template/Policy/Search', title: 'Policy', type: 'link', accessarea: "25002:SWR"  },
                { path: 'App/Template/Client/Search', title: 'Client', type: 'link', accessarea: "25003:SWR"  },
                { path: 'App/Template/Report/Search', title: 'Report', type: 'link', accessarea: "25004:SWR"  },
                { path: 'App/Template/Claim/Search', title: 'Claim', type: 'link', accessarea: "25005:SWR" }, 
                
			]
        },
        {
            path: 'App/Client/Search', title: 'Client', icon: 'user', type: 'link', accessarea: "25007:SWR"
        },
        {
            path: 'App/Offer/Search', title: 'Offer', icon: 'git-pull-request', type: 'link', accessarea: "25008:SWR"
        },
        {
            path: 'App/Policy/Search', title: 'Policy', icon: 'airplay', type: 'link', accessarea: "25009:SWR"
        },     
        {
            path: 'App/Claim/Search', title: 'Claims', icon: 'command', type: 'link', accessarea: "25013:SWR"
        },
        {
            path: 'App/Collection/Search', title: 'Collection', icon: 'command', type: 'link', accessarea: "25017:SWR"
        },
        {
            path: 'App/Report/Search', title: 'Reports', icon: 'command', type: 'link', accessarea: "25018:SWR"
        },
        {
            path: 'App/Promotion/Search', title: 'Promotion', icon: 'percent', type: 'link', accessarea: "25030:SWR"
        }
	]
	// Array
	items = new BehaviorSubject<Menu[]>(this.MENUITEMS);


}
